const url = "https://uniten-umbraco.azurewebsites.net/"

export const apis = {
    domain:url,
    uniten_api: url + 'Umbraco/Api/UnitenApi',
    umbraco_delivery_api: url + 'umbraco/delivery/api/v2/content/item',
    base_url:"https://unitendev.blob.core.windows.net/mysitestorage",
    umbraco_url : `https://umbraco.koyauniversity.org/umbraco/api/`,
    baseUrl : "https://fresh-tropical-colony.glitch.me/",
    // baseUrl : "http://localhost:5001/",
    getHomeVideo:"gethomevideo",
    getScholar:"getScholar",
    getCampusLife:"getcampuslife",
    getGraduate:"getgraduate",
    getEducator:"geteducator",
    getInternationalOffice:"getinternationaloffice",
    getPartners:"getpartners",
    getCourses:"getCourses",

}